import { render, staticRenderFns } from "./PanelAlpha.vue?vue&type=template&id=b61f78b4&scoped=true&lang=pug&"
import script from "./PanelAlpha.vue?vue&type=script&lang=js&"
export * from "./PanelAlpha.vue?vue&type=script&lang=js&"
import style0 from "./PanelAlpha.vue?vue&type=style&index=0&id=b61f78b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61f78b4",
  null
  
)

export default component.exports